/* istanbul ignore file */
import React, { useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { DeleteButton } from 'framework/ui/ui-builder';
import {
  RECRUITING_VACANCY_CANCEL_NON_REVIEWED_VACANCY,
  VACANCY_CANCEL_REASON_MAX_LENGTH,
  VACANCY_STATUS,
  useVacancyGroupService,
} from 'domain/shared/newVacancy';
import { useFieldHelper } from 'framework/ui/field';
import { FormFieldsData, TextArea } from 'framework/form';
import { useShowContext } from 'framework/show';
import { RECRUITING_CONTEXT } from '../../../RecruitingContext';

const CancelVacancyBeforeReviewButton = ({
  statusSource,
  setGeneralContextData,
}: {
  statusSource: string;
  setGeneralContextData: () => {};
}) => {
  const { cancelVacancyBeforeReview } = useVacancyGroupService();
  const { isGranted } = useAuthorization();

  const { data } = useShowContext();
  const { id } = data.getData();

  const [cancellationReason, setCancellationReason] = useState<string>();
  const [cancellationReasonErrors, setCancellationReasonErrors] = useState<string[]>();

  const { getValue } = useFieldHelper({ source: statusSource });
  const status = getValue();

  if (status !== VACANCY_STATUS.REQUIRES_REVIEW) {
    return null;
  }

  const getCancellationReasonErrors = (reason?: string) => {
    if (!reason) {
      return ['Reason should be provided to cancel the vacancy'];
    }

    if (reason.length > VACANCY_CANCEL_REASON_MAX_LENGTH) {
      return [`Cancellation reason max length is ${VACANCY_CANCEL_REASON_MAX_LENGTH}`];
    }

    return [];
  };

  const onCancellationReasonChange = (values: FormFieldsData) => {
    setCancellationReason(values.cancellationReason);
    setCancellationReasonErrors(getCancellationReasonErrors(values.cancellationReason));
  };

  return isGranted(RECRUITING_VACANCY_CANCEL_NON_REVIEWED_VACANCY, RECRUITING_CONTEXT) ? (
    <DeleteButton
      displayMessage="Do you really want to cancel this vacancy?"
      modalChildren={
        <TextArea
          source="cancellationReason"
          label="Cancellation reason"
          value={cancellationReason}
          onChangeCallback={onCancellationReasonChange}
          errorMessages={cancellationReasonErrors}
          isRequired
        />
      }
      deleteMethod={() => cancelVacancyBeforeReview(id!, cancellationReason)}
      afterDelete={{
        successMessage: 'Vacancy has been successfully canceled.',
        errorMessage: "Can't cancel vacancy.",
        execute: () => {
          if (setGeneralContextData) {
            setGeneralContextData();
          }
        },
      }}
      permissionToCheck={null}
      buttonText="Cancel Vacancy"
      confirmBtnProps={{ disabled: !cancellationReason || Boolean(cancellationReasonErrors?.length) }}
      color="error"
      variant="outlined"
    />
  ) : null;
};

export default CancelVacancyBeforeReviewButton;
